import React from "react";
interface Props {
  replacementLink: string;
}
const ReplacementButton = ({
  replacementLink
}: Props) => {
  return <a href={replacementLink} data-sentry-component="ReplacementButton" data-sentry-source-file="ReplacementButton.tsx">
      <button type="submit" className="btn btn-info btn-large" style={{
      width: "100%",
      paddingTop: "16px",
      paddingBottom: "16px",
      paddingLeft: "0px",
      paddingRight: "0px"
    }} data-testid="replacementBtn">
        View Replacement Item
      </button>
    </a>;
};
export default ReplacementButton;